import { render, staticRenderFns } from "./video.vue?vue&type=template&id=1d5f5ffc&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f5ffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5f5ffc')) {
      api.createRecord('1d5f5ffc', component.options)
    } else {
      api.reload('1d5f5ffc', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=1d5f5ffc&scoped=true", function () {
      api.rerender('1d5f5ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mediaManage/recommendStrategy/components/video.vue"
export default component.exports